import React, { forwardRef, HTMLAttributes, CSSProperties } from 'react'

export type ItemProps = HTMLAttributes<HTMLDivElement> & {
  id: string
  withOpacity?: boolean
  isDragging?: boolean
  animation?: string
}

const Item = forwardRef<HTMLDivElement, ItemProps>(({ children, id, withOpacity, isDragging, style, ...props }, ref) => {
  const inlineStyles: CSSProperties = {
    opacity: withOpacity ? '0.5' : '1',
    transformOrigin: '50% 50%',
    borderRadius: '10px',
    cursor: isDragging ? 'grabbing' : 'grab',
    display: 'flex',
    gap: '8px',
    justifyContent: 'center',
    alignItems: 'center',
    transform: isDragging ? 'scale(1.05)' : 'scale(1)',
    ...style,
  }

  return <div ref={ref} style={inlineStyles} {...props}>{children}</div>
})

export default Item
